import React, {useState} from 'react';
import {Popup, Icon, Button} from 'semantic-ui-react';

const ConfirmButton = ({
  onConfirm,
  loading,
  text,
  loadingText = 'Loading...',
  confirmText = 'Are you sure?',
  confirmPosition = 'bottom left',
  icon,
  faIconName,
  infoPopup = false,
  infoText = 'This is the default information text.',
  warningColor,
  ...props
}) => {
  const [open, setOpen] = useState(false);
  const toggleOpen = () => {
    setOpen(!open);
  };
  const onClose = () => {
    setOpen(false);
  };
  const onConfirmClick = () => {
    onConfirm();
    onClose();
  };
  return (
    <Popup
      open={open}
      onClose={onClose}
      trigger={
        <Popup
          trigger={
            <Button
              className="clear"
              type="button"
              icon={icon}
              disabled={loading}
              {...props}
              onClick={toggleOpen}
            >
              {icon && <Icon name={faIconName} />}
              {icon && ' '}
              <span>{loading ? loadingText : text}</span>
            </Button>
          }
          position="top center"
          content={infoText}
          disabled={!infoPopup}
          basic
        ></Popup>
      }
      content={
        <Button
          style={{
            backgroundColor: warningColor,
            color: 'white',
          }}
          type="button"
          onClick={onConfirmClick}
          disabled={loading}
        >
          {confirmText}
        </Button>
      }
      position={confirmPosition}
      on="click"
    />
  );
};

export default ConfirmButton;
